import React, { Fragment } from 'react';

const About = () => {
  console.log('hello');
  return (
    <Fragment>
      <h1>About Github Finder</h1>
      <h3>It uses Github API</h3>
      <h3>You can search any user and see his github profile</h3>
      <h3>Also you see recent 5 repos of that user</h3>
      <h2>
        {' '}
        Go to Home again find your friend's github Profile in some different way
      </h2>
    </Fragment>
  );
};

export default About;
